(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('rmsActivityReplyInputPanel', rmsActivityReplyInputPanelComponent);

    function rmsActivityReplyInputPanelComponent() {
        return {
            restrict: 'E',
            scope: {
                options: '=',
                original: '=?',
                closeReply: '&?'
            },
            templateUrl: 'common/app/components/activities/activity-input-panel/activity-reply-input-panel',
            controller: rmsActivityReplyInputPanelComponentCtrl,
            controllerAs: 'vm',
            bindToController: true,
        };
    }

    function rmsActivityReplyInputPanelComponentCtrl(ActivitiesService, $timeout, lodash, ActivityInputService) {
        var vm = this;
        var inputOptions = {};

        this.$onInit = function() {
            vm.currentData = {};

            inputOptions = vm.options.inputOptions;

            lodash.set(inputOptions, 'onChangeInstructions', [
                {name: 'sel_email_from', type: 'setSignature'}
            ]);

            lodash.set(inputOptions, 'signatureSettings', {
                fieldName: 'txtbox_description'
            });

            // console.log(inputOptions);

            init();

            vm.add = add;
            vm.discard = discard;
            vm.hideReply = function() {
                if (vm.closeReply && typeof vm.closeReply === typeof function() {}) {
                    vm.closeReply();
                }
            };
        }

        function init() {
            vm.selectedActivityType = vm.options.activityType;
            vm.currentData = ActivityInputService.initInputOptions(
                vm.currentData,
                vm.selectedActivityType,
                inputOptions,
                lodash.get(vm.options, 'attachmentOptions', {})
            );
            vm.options.attachmentOptions = ActivitiesService.getAttachmentOptions();
            prepareDefaultModel();
        }

        function add() {
            $timeout(function() {
                vm.submitting = true;
                var promise = ActivitiesService.save(vm.getModel(), vm.selectedActivityType, inputOptions);
                promise.$promise.then(function(res) {
                    vm.inputValidationErrorMessage = '';
                    vm.submitting = false;
                    vm.discard();
                    ActivitiesService.refreshActivities();
                }, function(err) {
                    switch (err.status) {
                        case 422:
                            vm.inputValidationErrorMessage = lodash.flatMap(err.data.rules).join(', ');
                            break;
                    }
                    // mem.inputValidationError = err.data;
                    console.warn(err); // eslint-disable-line no-console
                    vm.submitting = false;
                });
            });
        }

        function discard() {
            vm.reset();
            vm.inputValidationErrorMessage = '';
        }

        function prepareDefaultModel() {
            const defaultModel = {};
            if (lodash.has(vm.options, 'subjectPrefix')) {
                defaultModel[vm.options.subjectPrefix.modelField] = vm.options.subjectPrefix.value + lodash.get(vm, 'original.' + vm.options.subjectPrefix.sourcePath, '')
            }
            vm.defaultModel = defaultModel;
        }
    }
})();